/* eslint-disable max-len */
import { Auth } from "aws-amplify";
import { CognitoData, getCurrentUserSession } from "./CognitoData";
import { dataService } from "../services/data.services";
import { GetBranchId } from "./GetBranchId";


export const CheckUserStatus = async () => {
    let user = true;
    const branch_id = await GetBranchId()
    try {
        const user1 = await CognitoData();
        let res = await dataService.GetAPI(`users/${user1.idToken.payload["email"]}${branch_id ? `?branch_id=${branch_id}` : ''}`);
        if (!res?.data?.data?.data?.status) {
            // User is deactivated, log out the user
            await Auth.signOut();
            localStorage.clear();
            window.location.reload();
        }
    } catch (error) {
        // Check if the error is related to network issues
        if (error.message && error.message.toLowerCase().includes("network")) {
            console.error("Network error occurred. Please check your internet connection.");
        } else {
            // Log out the user for other types of errors
            await Auth.signOut();
            localStorage.clear();
            window.location.reload();
        }
    }
    return user;
};



